import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F12198D8-62C4-4E6A-A201-5D33DB690736
 * name axis-y-arrow
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/axis-y-arrow.svg
 * tags
 * - Arrow 
 */
export const AxisYArrowIcon = createSvgIcon(<><path d="M22.5,20.5L17,21.96L18.53,19.35L12,15.58L2.61,21L1.61,19.27L11,13.85V3H13V13.85L19.53,17.61L21,15.03L22.5,20.5Z" /></>, 'AxisYArrowIcon');
export default AxisYArrowIcon